export const cyStyle = [
  {
    selector: "node",
    style: {
      "background-color": function (node) {
        return node.data("color");
      },
      "border-width": 2,
      "border-color": "#888888",
      width: function (node) {
        return node.data("width");
      },
      height: function (node) {
        return node.data("height");
      },
      label: function (node) {
        return node.data("label");
      },
      "text-wrap": "wrap",
      "text-max-width": "100px",
    },
  },
  {
    selector: "node:parent",
    style: {
      "background-opacity": 0.6,
    },
  },
  {
    selector: "node.highlight",
    style: {
      "border-color": "#08204d",
      "border-width": "2px",
    },
  },
  {
    selector: "node.semitransp",
    style: { opacity: "0.3" },
  },
  {
    selector: "node.searched",
    style: {
      "border-color": "#08204d",
      "background-color": "#08204d",
      "border-width": "2px",
    },
  },
  {
    selector: "edge.highlight",
    style: { "mid-target-arrow-color": "#FFF" },
  },
  {
    selector: "edge.semitransp",
    style: { opacity: "0.2" },
  },
  {
    selector: "edge",
    style: {
      "curve-style": "bezier",
      "line-color": "#a1a1a1",
      width: 0.8,
    },
  },
  {
    selector: "edge[arrow]",
    style: {
      "target-arrow-shape": "data(arrow)",
    },
  },
  {
    selector: ":selected",
    style: {
      "line-color": "SteelBlue",
      "line-width": "3px",
      "border-color": "#9d0303",
      "border-width": "5px",
      "color": "#9d0303",
      "font-weight": "bold",
    },
  },
  {
    selector: "edge:selected",
    style: {
      "line-color": "SteelBlue",
      "width": 6
    },
  },
];
